import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const TABLE_COLUMNS = [
  { key: "issueDate", label: "Issue Date", sort: true, search: false },
  { key: "policyHolder", label: "Policy Holder", sort: true, search: true },
  { key: "policyName", label: "Policy Name", sort: true, search: true },
  { key: "policyNo", label: "Policy No.", sort: true, search: true },
  { key: "renewalDate", label: "Renewal Date", sort: true, search: false },
  { key: "premium", label: "Premium", sort: true, search: false },
  { key: "sumAssured", label: "Sum Assured", sort: true, search: false },
  { key: "status", label: "Status", sort: true, search: true },
  { key: "policyDoc", label: "Policy Doc", sort: false, search: false },
  { key: "actions", label: "Actions", sort: false, search: false },
];

export default function AdminInsurance() {
  const [searchPolicy, setSearchPolicy] = useState("");
  const [dateFilterByRenewal, setDateFilterByRenewal] = useState(true); // true = Renewal Date, false = Issue Date
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectUser, setSelectUser] = useState("");
  const [activeTab, setActiveTab] = useState("life"); // "life" | "general"
  const [sortBy, setSortBy] = useState("issueDate");
  const [sortDir, setSortDir] = useState("asc");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [showGeneralInsuranceModal, setShowGeneralInsuranceModal] = useState(false);

  // General Insurance form state
  const [policyHolder, setPolicyHolder] = useState("");
  const [insuranceCompany, setInsuranceCompany] = useState("");
  const [policyName, setPolicyName] = useState("");
  const [agencyCode, setAgencyCode] = useState("");
  const [dateOfIssue, setDateOfIssue] = useState("");
  const [renewalDate, setRenewalDate] = useState("");
  const [policyNo, setPolicyNo] = useState("");
  const [previousPolicyNo, setPreviousPolicyNo] = useState("");
  const [premiumAmount, setPremiumAmount] = useState("");
  const [sumInsured, setSumInsured] = useState("");
  const [term, setTerm] = useState("");
  const [paymentSchedule, setPaymentSchedule] = useState("");
  const [status, setStatus] = useState("");
  const [noClaimBonus, setNoClaimBonus] = useState("");
  const [remark, setRemark] = useState("");
  const [commissionInRate, setCommissionInRate] = useState("");
  const [commissionOutRate, setCommissionOutRate] = useState("");

  const policies = []; // No data - empty state

  const openAddInsuranceModal = () => setShowGeneralInsuranceModal(true);
  const closeGeneralInsuranceModal = () => setShowGeneralInsuranceModal(false);

  const resetGeneralInsuranceForm = () => {
    setPolicyHolder("");
    setInsuranceCompany("");
    setPolicyName("");
    setAgencyCode("");
    setDateOfIssue("");
    setRenewalDate("");
    setPolicyNo("");
    setPreviousPolicyNo("");
    setPremiumAmount("");
    setSumInsured("");
    setTerm("");
    setPaymentSchedule("");
    setStatus("");
    setNoClaimBonus("");
    setRemark("");
    setCommissionInRate("");
    setCommissionOutRate("");
  };

  const handleSaveGeneralInsurance = (e) => {
    e.preventDefault();
    console.log({
      policyHolder,
      insuranceCompany,
      policyName,
      agencyCode,
      dateOfIssue,
      renewalDate,
      policyNo,
      previousPolicyNo,
      premiumAmount,
      sumInsured,
      term,
      paymentSchedule,
      status,
      noClaimBonus,
      remark,
      commissionInRate,
      commissionOutRate,
    });
    resetGeneralInsuranceForm();
    closeGeneralInsuranceModal();
  };

  const handleCancelGeneralInsurance = () => {
    resetGeneralInsuranceForm();
    closeGeneralInsuranceModal();
  };

  useEffect(() => {
    if (!showGeneralInsuranceModal) return;
    const onEscape = (e) => {
      if (e.key === "Escape") handleCancelGeneralInsurance();
    };
    document.addEventListener("keydown", onEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onEscape);
      document.body.style.overflow = "";
    };
  }, [showGeneralInsuranceModal]);

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const toggleSelectAll = (e) => {
    if (e.target.checked) setSelectedIds(new Set(policies.map((p) => p.id)));
    else setSelectedIds(new Set());
  };

  const toggleSelectOne = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const SortIcon = ({ columnKey }) =>
    TABLE_COLUMNS.find((c) => c.key === columnKey)?.sort ? (
      <button
        type="button"
        className="btn btn-link p-0 ms-1 border-0"
        style={{ color: sortBy === columnKey ? teal : "#64748b", fontSize: "11px" }}
        onClick={() => toggleSort(columnKey)}
        aria-label={`Sort by ${columnKey}`}
      >
        <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
      </button>
    ) : null;

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Insurance</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Insurance
                </li>
              </ol>
            </nav>
          </div>

          {/* Top filter row */}
          <div style={cardStyle}>
            <div className="d-flex flex-wrap align-items-center gap-3">
              {/* Search Policy */}
              <div className="d-flex align-items-center" style={{ minWidth: 200, flex: "1 1 200px" }}>
                <span
                  className="d-flex align-items-center justify-content-center rounded-start"
                  style={{
                    padding: "8px 10px",
                    border: "1px solid #e2e8f0",
                    borderRight: "none",
                    backgroundColor: "#fff",
                    color: "#64748b",
                  }}
                >
                  <i className="fa-solid fa-filter" style={{ fontSize: "12px" }} />
                </span>
                <select
                  value={searchPolicy}
                  onChange={(e) => setSearchPolicy(e.target.value)}
                  style={{
                    ...inputStyle,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    flex: 1,
                  }}
                >
                  <option value="">Search Policy</option>
                </select>
              </div>

              {/* Issue Date / Renewal Date toggle */}
              <div className="d-flex align-items-center gap-2">
                <span className="small text-secondary">Issue Date</span>
                <div
                  role="switch"
                  aria-checked={dateFilterByRenewal}
                  tabIndex={0}
                  onClick={() => setDateFilterByRenewal((v) => !v)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setDateFilterByRenewal((v) => !v);
                    }
                  }}
                  style={{
                    width: 48,
                    height: 26,
                    borderRadius: 13,
                    background: dateFilterByRenewal ? teal : "#cbd5e1",
                    cursor: "pointer",
                    position: "relative",
                    transition: "background 0.2s",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: 2,
                      left: dateFilterByRenewal ? 24 : 2,
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                      transition: "left 0.2s",
                    }}
                  />
                </div>
                <span className="small text-secondary">Renewal Date</span>
              </div>

              {/* Date range */}
              <div className="d-flex align-items-center gap-2">
                <span className="position-relative d-inline-block" style={{ width: 130 }}>
                  <input
                    type="text"
                    placeholder="DD-MM-YYYY"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    style={{ ...inputStyle, paddingLeft: 36 }}
                    maxLength={10}
                  />
                  <span
                    className="position-absolute"
                    style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "#64748b", pointerEvents: "none", fontSize: "14px" }}
                    aria-hidden
                  >
                    📅
                  </span>
                </span>
                <span style={{ color: "#64748b" }}>-</span>
                <input
                  type="text"
                  placeholder="DD-MM-YYYY"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  style={{ ...inputStyle, width: 130 }}
                  maxLength={10}
                />
              </div>

              {/* Select User */}
              <span className="position-relative d-inline-block ms-auto" style={{ minWidth: 160 }}>
                <select
                  value={selectUser}
                  onChange={(e) => setSelectUser(e.target.value)}
                  style={{
                    ...inputStyle,
                    background: teal,
                    color: "#fff",
                    borderColor: teal,
                    paddingLeft: 36,
                  }}
                >
                  <option value="">Select User</option>
                </select>
                <span
                  className="position-absolute"
                  style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.9)", pointerEvents: "none" }}
                  aria-hidden
                >
                  <i className="fa-solid fa-user" style={{ fontSize: "14px" }} />
                </span>
              </span>
            </div>
          </div>

          {/* Tabs + Bulk actions + Table */}
          <div style={cardStyle}>
            {/* Tabs and actions row */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <div className="d-flex">
                <button
                  type="button"
                  onClick={() => setActiveTab("life")}
                  className="border-0 bg-transparent pb-2 px-0 me-4"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "life" ? teal : "#94a3b8",
                    borderBottom: activeTab === "life" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  Life Insurance
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab("general")}
                  className="border-0 bg-transparent pb-2 px-0"
                  style={{
                    fontWeight: 600,
                    fontSize: "15px",
                    color: activeTab === "general" ? teal : "#94a3b8",
                    borderBottom: activeTab === "general" ? `3px solid ${teal}` : "3px solid transparent",
                    cursor: "pointer",
                  }}
                >
                  General Insurance
                </button>
              </div>
              <div className="d-flex align-items-center gap-3">
                <button
                  type="button"
                  className="d-flex align-items-center gap-2 border-0 bg-transparent text-secondary"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                >
                  <i className="fa-solid fa-upload" />
                  Bulk Upload
                </button>
                <button
                  type="button"
                  onClick={openAddInsuranceModal}
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    fontWeight: 600,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  Add Insurance
                </button>
                <button
                  type="button"
                  className="d-flex align-items-center justify-content-center border-0 rounded"
                  style={{
                    width: 40,
                    height: 40,
                    background: "#f1f5f9",
                    color: "#64748b",
                    cursor: "pointer",
                  }}
                  title="Export to XLS"
                >
                  <i className="fa fa-file-excel" style={{ fontSize: "18px" }} />
                </button>
              </div>
            </div>

            {/* Table */}
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8fafc" }}>
                    <th style={{ padding: "10px 12px", width: 44 }}>
                      <input
                        type="checkbox"
                        checked={policies.length > 0 && selectedIds.size === policies.length}
                        onChange={toggleSelectAll}
                        style={{ accentColor: teal }}
                        aria-label="Select all"
                      />
                    </th>
                    {TABLE_COLUMNS.map(({ key, label, sort, search }) => (
                      <th
                        key={key}
                        className="text-nowrap"
                        style={{
                          padding: "10px 12px",
                          fontWeight: 600,
                          color: "#334155",
                          borderBottom: sortBy === key ? `2px solid ${teal}` : undefined,
                        }}
                      >
                        {label}
                        <SortIcon columnKey={key} />
                        {search && (
                          <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden />
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {policies.length === 0 ? (
                    <tr>
                      <td colSpan={TABLE_COLUMNS.length + 1} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                        <div className="text-center">
                          <div className="mb-2">
                            <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b" }} aria-hidden />
                          </div>
                          <div style={{ fontWeight: 600, color: "#334155", marginBottom: "6px" }}>No data available.</div>
                          <div style={{ fontSize: "13px", color: "#94a3b8" }}>
                            Tip : You could try again by selecting a different filter or date range.
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    policies.map((row) => (
                      <tr key={row.id}>
                        <td style={{ padding: "10px 12px" }}>
                          <input
                            type="checkbox"
                            checked={selectedIds.has(row.id)}
                            onChange={() => toggleSelectOne(row.id)}
                            style={{ accentColor: teal }}
                          />
                        </td>
                        <td style={{ padding: "10px 12px" }}>{row.issueDate}</td>
                        <td style={{ padding: "10px 12px" }}>{row.policyHolder}</td>
                        <td style={{ padding: "10px 12px" }}>{row.policyName}</td>
                        <td style={{ padding: "10px 12px" }}>{row.policyNo}</td>
                        <td style={{ padding: "10px 12px" }}>{row.renewalDate}</td>
                        <td style={{ padding: "10px 12px" }}>{row.premium}</td>
                        <td style={{ padding: "10px 12px" }}>{row.sumAssured}</td>
                        <td style={{ padding: "10px 12px" }}>{row.status}</td>
                        <td style={{ padding: "10px 12px" }}>—</td>
                        <td style={{ padding: "10px 12px" }}>
                          <button type="button" className="btn btn-link p-0 text-secondary" aria-label="Actions">
                            <i className="fa fa-ellipsis-v" />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* General Insurance Modal */}
          {showGeneralInsuranceModal && (
            <div
              role="dialog"
              aria-modal="true"
              aria-labelledby="general-insurance-modal-title"
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                padding: "24px",
              }}
              onClick={(e) => e.target === e.currentTarget && handleCancelGeneralInsurance()}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
                  maxWidth: 640,
                  width: "100%",
                  maxHeight: "90vh",
                  overflow: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Modal header */}
                <div
                  style={{
                    background: teal,
                    color: "#fff",
                    padding: "14px 20px",
                    borderRadius: "8px 8px 0 0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h2 id="general-insurance-modal-title" className="mb-0" style={{ fontSize: "18px", fontWeight: 700 }}>
                    General Insurance
                  </h2>
                  <button
                    type="button"
                    onClick={handleCancelGeneralInsurance}
                    className="border-0 bg-transparent text-white"
                    style={{ fontSize: "20px", cursor: "pointer", padding: "0 4px", lineHeight: 1 }}
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>

                {/* Modal body - form */}
                <form onSubmit={handleSaveGeneralInsurance} style={{ padding: "20px" }}>
                  <div className="row g-3 mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Policy Holder:</label>
                      <select value={policyHolder} onChange={(e) => setPolicyHolder(e.target.value)} style={inputStyle}>
                        <option value="">Select</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Insurance Company:</label>
                      <select value={insuranceCompany} onChange={(e) => setInsuranceCompany(e.target.value)} style={inputStyle}>
                        <option value="">Select</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-semibold text-secondary mb-1">Policy Name</label>
                      <input
                        type="text"
                        placeholder="Enter / Select Policy Name"
                        value={policyName}
                        onChange={(e) => setPolicyName(e.target.value)}
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Agency Code :</label>
                      <input type="text" value={agencyCode} onChange={(e) => setAgencyCode(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Date of Issue:</label>
                      <input type="text" placeholder="DD-MM-YYYY" value={dateOfIssue} onChange={(e) => setDateOfIssue(e.target.value)} style={inputStyle} maxLength={10} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Renewal Date :</label>
                      <input type="text" placeholder="DD-MM-YYYY" value={renewalDate} onChange={(e) => setRenewalDate(e.target.value)} style={inputStyle} maxLength={10} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Policy No.</label>
                      <input type="text" value={policyNo} onChange={(e) => setPolicyNo(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Previous Policy No :</label>
                      <input type="text" value={previousPolicyNo} onChange={(e) => setPreviousPolicyNo(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Premium Amount:</label>
                      <input type="text" value={premiumAmount} onChange={(e) => setPremiumAmount(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Sum Insured :</label>
                      <input type="text" value={sumInsured} onChange={(e) => setSumInsured(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Term :</label>
                      <input type="text" value={term} onChange={(e) => setTerm(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Payment Schedule:</label>
                      <select value={paymentSchedule} onChange={(e) => setPaymentSchedule(e.target.value)} style={inputStyle}>
                        <option value="">Select</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">Status:</label>
                      <select value={status} onChange={(e) => setStatus(e.target.value)} style={inputStyle}>
                        <option value="">Select</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small fw-semibold text-secondary mb-1">No Claim Bonus:</label>
                      <input type="text" value={noClaimBonus} onChange={(e) => setNoClaimBonus(e.target.value)} style={inputStyle} />
                    </div>
                  </div>

                  <div className="row g-3 mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Policy Document :</label>
                      <button
                        type="button"
                        style={{
                          background: "#e0f7f5",
                          color: teal,
                          border: `1px solid ${teal}`,
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        Attach File
                      </button>
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Remark :</label>
                      <textarea
                        rows={3}
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        style={{ ...inputStyle, resize: "vertical" }}
                        placeholder="Enter remark"
                      />
                    </div>
                  </div>

                  <div className="row g-3 mb-4">
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Commission In Rate:</label>
                      <input type="text" value={commissionInRate} onChange={(e) => setCommissionInRate(e.target.value)} style={inputStyle} />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label small fw-semibold text-secondary mb-1">Commission Out Rate:</label>
                      <input type="text" value={commissionOutRate} onChange={(e) => setCommissionOutRate(e.target.value)} style={inputStyle} />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-3">
                    <button
                      type="submit"
                      style={{
                        background: teal,
                        color: "#fff",
                        border: "none",
                        padding: "10px 28px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelGeneralInsurance}
                      style={{
                        background: "#f1f5f9",
                        color: "#475569",
                        border: "1px solid #e2e8f0",
                        padding: "10px 28px",
                        borderRadius: "8px",
                        fontWeight: 600,
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
